
define(
	'C3.ShoppingExtensions.PDP'
,   [
		'C3.ShoppingExtensions.PDP.View',
		'Profile.Model',
		'ProductDetails.Base.View',
		'ProductDetails.ImageGallery.View',
		'ProductViews.Price.View',
		'Cart.AddToCart.Button.View',
		'C3.ShoppingExtensions.HomeHeader',
		'ItemRelations.RelatedItem.View',
		'LiveOrder.Model',
		'Utils',
		'C3.ShoppingExtensions.PDP.MakeAnOffer.View',
		'Session',
		'C3.ShoppingExtensions.YouMayAlsoNeed.View',
		'C3.ShoppingExtensions.LoginRegister.View',
		'C3.ShoppingExtensions.WarrantyPopup.View',
		'ProductDetails.Full.View',
		'C3.ShoppingExtensions.PDP.KitUpFunctionality.View',
		'C3.ShoppingExtensions.PDP.CompleteYourKitFunctionality.View',
		'C3.ShoppingExtensions.YouMayAlsoNeed.MainView',
		'ProductDetails.Quantity.View',
		"C3.ShoppingExtensions.PDP.AddToWishlist.View",
		"C3.ShoppingExtensions.PDP.AddToWishlist.Rightside.View",
		"C3.ShoppingExtensions.PDP.ContactForPricing.View",
		'C3.ShoppingExtensions.PDP.Qty.ToolTip.View',
		"Cart.Confirmation.View",
		'LiveOrder.Line.Model',
		'InstrumentationAddToCart',
		'Loggers',
		'Cart.Confirmation.Helpers',
		'Handlebars',
		'ProductList.Item.Model'
	]
,   function (
		PDPTabbedView,
		ProfileModel,
		ProductDetailsBaseView,
		ProductDetailsImageGalleryView,
		ProductViewsPriceView,
		CartAddToCartButtonView,
		NXTurnShoppingExtensionsHomeHeader,
		ItemRelationsRelatedItemView,
		LiveOrderModel,
		Utils,
		MakeAnOfferView,
		Session,
		YouMayAlsoNeedView,
		LoginRegisterView,
		WarrantyPopupView,
		ProductDetailsFullView,
		KitUpFunctionalityView,
		CompleteYourKitFunctionalityView,		
		YouMayAlsoNeedMainView,
		ProductDetailsQuantityView,
		AddToWishlistView,
		AddToWishlistRightSideView,
		ContactForPricingView,
		PDPQtyToolTip,
		CartConfirmationView,
		LiveOrderLineModel,
		InstrumentationAddToCart,
		Loggers,
		CartConfirmationHelpers,
		Handlebars,
		ProductListItemModel
	)
{
	'use strict';

	Handlebars.registerHelper('allNotTrue', function(a, b, options) {
	  if (!a && !b) {
	    return options.fn(this);
	  } else {
	    return options.inverse(this);
	  }
	});

		Handlebars.registerHelper('ifCond', function(v1, v2, options) {
	    return v1 == v2 ? options.fn(this) : options.inverse(this);
	});



	return  {
		mountToApp: function mountToApp (container)
		{
			var environment = container.getComponent("Environment");
			var layout = container.getComponent('Layout');
			var pageType = container.getComponent('PageType');

		
			var Configuration = environment.application.Configuration;

			var pdpComponent = container.getComponent('PDP');
			//console.log(pdpComponent)
           

			var profile = ProfileModel.getInstance()
			//,   is_loading = !Configuration.get('performance.waitForUserProfile', true) && ProfileModel.getPromise().state() !== 'resolved'
            ,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'
           	   

             layout.addChildView('PDP.Tabbed.Content', function () {
				//console.log(layout)
				var pdp = container.getComponent("PDP");
				var iteminfo = pdp.getItemInfo();
				//console.log(iteminfo)
			  return new PDPTabbedView({
			  	application: environment.application,
			  	layout : layout,
			  	iteminfo : iteminfo,
			  	configuration : Configuration,
			  	container : container
			  });
			}); 


            layout.addChildView('Kitup.Items.Section', function () {
				var pdp = container.getComponent("PDP");
				var iteminfo = pdp.getItemInfo();
			  return new KitUpFunctionalityView({
			  	application: environment.application,
			  	layout : layout,
			  	iteminfo : iteminfo,
			  	configuration : Configuration,
			  	container : container
			  });
			}); 

             pdpComponent.addChildView('YouMayAlsoNeed.Items', function () {
			   var iteminfo = pdpComponent.getItemInfo()
			   ,   item = iteminfo.item
			   ,   internalid = item.internalid
				//console.log(internalid)
			  /*return new YouMayAlsoNeedView({
			  	application: environment.application,
			  	layout : layout,
			  	itemsIds : internalid,
			  	configuration : Configuration,
			  	container : container
			  });*/
			   
			   return new YouMayAlsoNeedMainView({
			  	application: environment.application,
			  	layout : layout,
			  	itemsIds : internalid,
			  	configuration : Configuration,
			  	container : container
			  });
			}); 

              pdpComponent.addChildView('CompleteYourKit.Section', function () {
			   var iteminfo = pdpComponent.getItemInfo()
			   ,   item = iteminfo.item
			   ,   internalid = item.internalid
			   
			   return new CompleteYourKitFunctionalityView({
			  	application: environment.application,
			  	layout : layout,
			  	iteminfo : iteminfo,
			  	configuration : Configuration,
			  	container : container
			  });
			});	
             /*layout.addToViewEventsDefinition(
				'C3.ShoppingExtensions.YouMayAlsoNeed.View',
				'click [data-action="pdp-youmay-click"]',
				function (e) 
				{
					console.log(e)
				}
			);*/


            ItemRelationsRelatedItemView.prototype.getContext = _.wrap(ItemRelationsRelatedItemView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);	

			var applyStrikeThroughPrice = false
			,   special_formatted_pricelevel1 = ''
			,   special_formatted_pricelevel5 = ''
			,   qtyAvailableInv = this.model.get('custitem_qty_available_inv')
			,   qtyAvailableKit = this.model.get('custitem_qty_available_kit')
			,   itemType = this.model.get('itemtype')
			,   enableOutOfStock = this.model.get('custitem_celigo_shopify_enable_out_sto')
			,   isWebsiteCategoryProduct = this.model.get('custitem157') 
			,   outOfStockDisplay = this.model.get('custitem_aa_out_of_stock_display')
            ,   showContactForPricingButton = false
            ,   showOutOfStockButton = false
			,   showOutofStock = false;

			var lightboxItem = this.model.get('custitem_lightbox_item_url_component');
			var finalLightboxUrl = ''
			,   isKitItemOnly = this.model.get('custitem_kit_item_only') 



			if(qtyAvailableInv == undefined)
				qtyAvailableInv = 0;

			if(qtyAvailableKit == undefined)
				qtyAvailableKit = 0;

			if(lightboxItem !== '' /*&& kititemonly == true*/)
			{
				finalLightboxUrl = "/"+lightboxItem;
			}

			if(itemType == "Kit")
			{
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableKit <= 0 && enableOutOfStock == false)
				{
					showOutofStock = true;

					if(outOfStockDisplay == "Out of Stock")
						showOutOfStockButton = true;
					else if(outOfStockDisplay == "Contact for Pricing")
						showContactForPricingButton = true;
				}
			}
			else if(itemType == 'InvtPart' || itemType == 'Assembly')
			{
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableInv <= 0 && enableOutOfStock == false)
				{
					showOutofStock = true;

					if(outOfStockDisplay == "Out of Stock")
						showOutOfStockButton = true;
					else if(outOfStockDisplay == "Contact for Pricing")
						showContactForPricingButton = true;
				}
			}

			
			
			//console.log(enableOutOfStock);

			var price_detail = this.model.get('onlinecustomerprice_detail')
			,   ItemRelationsPrice = ''
			//console.log(price_detail)
			if(price_detail)
			{
				var price_container_object = this.model.getPrice()
				,   pricelevel1 = this.model.get('pricelevel1')
				,   pricelevel1_formatted = this.model.get('pricelevel1_formatted')
				,   onlinecustomerprice_detail = price_detail
				,   applyStrikeThroughPrice = false
				,   onlineprice = onlinecustomerprice_detail.onlinecustomerprice
				,   pricelevel5 = onlinecustomerprice_detail.onlinecustomerprice
				,   ItemRelationsPrice = onlinecustomerprice_detail.onlinecustomerprice_formatted
				,	savePrice = 0
				,	savePercent=0
				,	discountPercentage=0;

				if(pricelevel1 && pricelevel1 > onlineprice)
				{
					//console.log(pricelevel1.toLocaleString('en'));
					applyStrikeThroughPrice = true;
				}

				if(pricelevel1_formatted)
					special_formatted_pricelevel1 = pricelevel1_formatted.substr(0, pricelevel1_formatted.indexOf('.'));
				
				if(price_container_object)
				{
					onlineprice = price_container_object.price_formatted;
					if(onlineprice)
					special_formatted_pricelevel5 = onlineprice.substr(0, onlineprice.indexOf('.'));
				}	

				var currPrice = pricelevel5 || pricelevel1 || 0; 
	            if( currPrice < 5){
	                showOutofStock = true;
	            }
			 }


			 var itemQtyInCurrentOrder = 0;

			//using lightbox field condition instead of relateditems
			//if(subCategoriesList.length  == 0)
			if(lightboxItem == '')
			{
				var self = this;
				var liveOrder = LiveOrderModel.getInstance();
				//console.log(liveOrder.get('lines'))
				
				var lineData=liveOrder.get('lines').filter(function(line)
				{	
					return line.get('item').get('internalid') == self.model.get('internalid');
		       	});
		       	if(lineData.length > 0)
		       	{
		       	var lineQuantity=lineData[0].get('quantity');
		       	itemQtyInCurrentOrder = lineQuantity;
		       	}
			}

			var url = '';
			if(ProfileModel.getInstance().hidePrices())
			{
				 url = Session.get('touchpoints.login') +
                '&origin=' +
                (Configuration.get('currentTouchpoint') || 'home') +
                '&origin_hash=';

                url = url +
                encodeURIComponent(this.options.origin === 'PDPQUICK'
                    ? this.model.generateURL().replace('/', '')
                    : Backbone.history.fragment);
			}

			 /*if(isKitItemOnly == true)
                showOutofStock = true;*/
			 
             if(applyStrikeThroughPrice)
				{
					savePrice = parseFloat((Number(pricelevel1) - Number(pricelevel5)).toFixed(2));
					discountPercentage = (savePrice / pricelevel1) * 100;
					savePercent=Math.trunc(discountPercentage)+ "%";
				}

			_.extend(result, {					
					     itemQtyInCurrentOrder : itemQtyInCurrentOrder
			        ,    itemQtyInCurrentOrderCheck : itemQtyInCurrentOrder > 0
			        ,    itemQtyInCurrentOrderCheck2 : itemQtyInCurrentOrder < 1
			        ,    origin : 'ItemRelations'/*this.options.origin*/
			        ,    applyStrikeThroughPrice : applyStrikeThroughPrice
					,    BasePriceFormatted : special_formatted_pricelevel1
					,    OnlinePriceFormatted : special_formatted_pricelevel5
					,    showOutofStock : showOutofStock
					,    plpPrice : ItemRelationsPrice
					,    itemId: this.model.get('_id')
					,	 isWebsiteCategoryProduct : isWebsiteCategoryProduct
					,	 lightBoxItemURL : finalLightboxUrl
					,    hidePricing: ProfileModel.getInstance().hidePrices()
					,    urlLogin: url
					,	 savePrice : savePrice
					, 	 savePercent:savePercent
					,    showContactForPricingButton : showContactForPricingButton
                    ,    showOutOfStockButton : showOutOfStockButton
				});
			//console.log(result)
			
			return result;
			
			});
            

            _.extend(CartAddToCartButtonView.prototype, {
            	 addToCart: function (e) {
            	 	 try {
				            setTimeout(function() {
				                for (var i = 0; i < document.getElementsByClassName('bx-pager-link').length; i++) {
				                    var activeImgOptionURL = ((
				                        document.getElementsByClassName('bx-pager-link')[i].children[0]
				                    )).currentSrc.split('?')[0];
				                    var mainImg = document.getElementsByClassName(
				                        'product-details-image-gallery-container'
				                    )[i + 1].innerHTML;
				                    var mainImgSplit = mainImg.split(' ');
				                    var mainImgSplitURL = mainImgSplit[1].split('?');

				                    if (mainImgSplitURL[0] != 'src="' + activeImgOptionURL) {
				                        mainImgSplitURL[0] = 'src=' + activeImgOptionURL;
				                        mainImgSplit[1] = mainImgSplitURL.join('?');
				                        var newImgSrc = mainImgSplit.join(' ');
				                        document.getElementsByClassName('product-details-image-gallery-container')[
				                            i + 1
				                        ].innerHTML = newImgSrc;
				                    }
				                }
				            }, 3000);
				        } catch (e) {
				            console.warn(
				                'The Zoom bug fix is throwing an error (Cart.AddToCart.Button.View): ' +
				                    JSON.stringify(e)
				            );
				        }
				        e.preventDefault();
				        const self = this;
				        let cart_promise;

				        if (
				            !this.model.areAttributesValid(['options', 'quantity'], self.getAddToCartValidators())
				        ) {
				            return;
				        }

				        if (!this.model.isNew() && this.model.get('source') === 'cart') {
				            cart_promise = this.cart.updateProduct(this.model);
				            cart_promise.done(function() {
				                self.options.application.getLayout().closeModal();
				            });
				        } else {
				            const line = LiveOrderLineModel.createFromProduct(this.model);
				            const itemTrack = InstrumentationAddToCart.itemToTrack(line);
				            
				            const loggers = Loggers.Loggers.getLogger();
				            //console.log(loggers)
				            const actionId = loggers.start('Add to Cart');
				            cart_promise = this.cart.addLine(line);
				            cart_promise.then(() => {
				                const addToCartOperationIds = InstrumentationAddToCart.getAddToCartOperationId(
				                    this.cart.get('lines').models,
				                    line
				                );
				                loggers.end(actionId, {
				                    operationIds: addToCartOperationIds,
				                    status: 'success',
				                    itemId: itemTrack.itemId,
				                    itemQuantity: itemTrack.itemQuantity
				                });
				            });

				            var pdp = container.getComponent("PDP");
							var iteminfo = pdp.getItemInfo();

							var pdp_layout = pdp.application.layout
							,   pdp_layout_currentview = pdp_layout.currentView
		                	//console.log(pdp_layout_currentview)

				            //Snippet for GTM DataLayer
				            /*var liveOrder = LiveOrderModel.getInstance();
				            var cartLinesDL = liveOrder.get('lines')
				            ,   cartLinesModelsDL = cartLinesDL.models
				            ,   finalCartArray = []

				            _.each(cartLinesModelsDL, function(line) {
				                var lineItem = line.get('item')
				                ,   lineItemName = lineItem.get('displayname')
				                ,   lineItemSKU = lineItem.get('itemid')
				                ,   lineQty = line.get('quantity')
				                ,   lineRate = line.get('rate')

				                finalCartArray.push({
				                    'item': lineItemName,
				                    'quantity':  lineQty,
				                    'price': lineRate,
				                    'unique_id': lineItemSKU

				                })
				            });

				            const gtm = GoogleTagManager;
				            const eventName = 'cartInfo';
				             const eventData = {
				                event: eventName,
				                cartUpdates: finalCartArray
				             }
				             Tracker.trigger(eventName, eventData);
				             gtm.pushData(eventData);
				             console.log(gtm.win)*/

				            CartConfirmationHelpers.showCartConfirmation(
				                cart_promise,
				                line,
				                self.options.application
				            );
				            pdp_layout_currentview.render();
				        }

				        cart_promise.fail(function(jqXhr) {
				            let error_details = null;
				            try {
				                if (jqXhr && jqXhr.responseText) {
				                    const response = JSON.parse(jqXhr.responseText);
				                    error_details = response.errorDetails;
				                }
				            } catch (error) {
				                console.error(error);
				            } finally {
				                if (error_details && error_details.status === 'LINE_ROLLBACK') {
				                    self.model.set('internalid', error_details.newLineId);
				                }
				            }
				        });

				        this.disableElementsOnPromise(cart_promise, e.target);

				        return false;
            	 }
            });

            CartAddToCartButtonView.prototype.getContext = _.wrap(CartAddToCartButtonView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);	

			var item = this.model.getItem();
			var itemPrice = item.get('onlinecustomerprice_detail').onlinecustomerprice;
			var lightboxItemURL = item.get('custitem_lightbox_item_url_component')
			,   finalLightboxUrl = ''
			,   showCustomizeKitButton = false
			,   qtyAvailableInv = item.get('custitem_qty_available_inv')
			,   qtyAvailableKit = item.get('custitem_qty_available_kit')
			,   itemType = item.get('itemtype')
			,   kititemonly = item.get('custitem_kit_item_only')
			,   enableOutOfStock = item.get('custitem_celigo_shopify_enable_out_sto')
			,   noQuantityAvailable = false
			,   itemCurrentAllowedQuantity = 0
			,   maxAllowedQtyReached = false
			,   showOutofStock = false;

			if(lightboxItemURL !== '' /*&& kititemonly == true*/)
			{
				finalLightboxUrl = "/"+lightboxItemURL;
				showCustomizeKitButton = true;
			}

			if(qtyAvailableInv == undefined)
				qtyAvailableInv = 0;

			if(qtyAvailableKit == undefined)
				qtyAvailableKit = 0;

			if(itemType == "Kit")
			{
				itemCurrentAllowedQuantity = qtyAvailableKit;
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableKit <= 0 && enableOutOfStock == false)
				{
					//noQuantityAvailable = true;
					showOutofStock = true;
				}
			}
			else if(itemType == 'InvtPart' || itemType == 'Assembly')
			{
				itemCurrentAllowedQuantity = qtyAvailableInv;
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableInv <= 0 && enableOutOfStock == false)
				{
					//noQuantityAvailable = true;
					showOutofStock = true;
				}
			}

			var itemQtyInCurrentOrder = 0;
			var self = this;
			var liveOrder = LiveOrderModel.getInstance();
			//console.log(liveOrder.get('lines'))
			
			var lineData=liveOrder.get('lines').filter(function(line)
			{	
				return line.get('item').get('internalid') == item.get('internalid');
	       	});
	       	if(lineData.length > 0)
	       	{
	       	var lineQuantity=lineData[0].get('quantity');
	       	itemQtyInCurrentOrder = lineQuantity;
	       	}

	       	if(itemCurrentAllowedQuantity == itemQtyInCurrentOrder)
            	maxAllowedQtyReached = true;

            //console.log(maxAllowedQtyReached)

			_.extend(result, {					
					showAddToCart : itemPrice !== null ? true : false,
					lightBoxItemURL : finalLightboxUrl,
					showCustomizeKitButton : showCustomizeKitButton,
					//noQuantityAvailable : noQuantityAvailable
					showOutofStock : showOutofStock,
					itemCurrentAllowedQuantity : itemCurrentAllowedQuantity,
					maxAllowedQtyReached : maxAllowedQtyReached

				});
			//console.log(result)
			return result;
			
			});

			CartConfirmationView.prototype.getContext = _.wrap(CartConfirmationView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);	

			    const item = this.model.get('item');

			    var currentQty = this.model.get('quantity')
		        ,   qtyAvailableInv = item.get('custitem_qty_available_inv')
		        ,   qtyAvailableKit = item.get('custitem_qty_available_kit')
		        ,   itemType = item.get('itemtype')
		        ,   enableOutOfStock = item.get('custitem_celigo_shopify_enable_out_sto')
		        ,   itemCurrentAllowedQuantity = 0
		        ,   maxAllowedQtyReached = false
		        ,   showOutofStock = false;

		        if(qtyAvailableInv == undefined)
		                qtyAvailableInv = 0;

		        if(qtyAvailableKit == undefined)
		            qtyAvailableKit = 0;

		        if(itemType == "Kit")
		        {
		            itemCurrentAllowedQuantity = qtyAvailableKit;
		            
		        }
		        else if(itemType == 'InvtPart')
		        {
		            itemCurrentAllowedQuantity = qtyAvailableInv;         
		        }

		        if(itemCurrentAllowedQuantity == currentQty)
		                maxAllowedQtyReached = true;


		         //console.log(maxAllowedQtyReached)

			_.extend(result, {					
					maxAllowedQtyReached : maxAllowedQtyReached

				});
			//console.log(result)
			return result;
			
			});


            layout.addToViewEventsDefinition(
				'ProductDetails.Full.View',
				'click [data-action="take-to-inventory-page-pdp"]',
			function (e) 
			{
				e.stopPropagation();
				e.preventDefault();

				var targetElement = $(e.currentTarget)
				,   data_productgroup = targetElement.attr('data-product-group');

				//console.log(data_productgroup) 
				if(data_productgroup){
				var url = '/inventory-page?group='+data_productgroup;
				window.open(url, '_blank');
			}
			});


			layout.addToViewEventsDefinition(
				'ProductDetails.Full.View',
				'click [data-action="show-warranty-popup"]',
			function (e) 
			{
				e.stopPropagation();
				e.preventDefault();

					var view = new WarrantyPopupView({
					application: layout.application
					});

					if (view)
					layout.showContent(view, {showInModal: true});
			});

			layout.addToViewEventsDefinition(
				'ProductDetails.Full.View',
				'click [data-action="show-serial-popup"]',
			function (e)
			{
				e.stopPropagation();
				e.preventDefault();

				var initialView = container._serialLotInitialView;
				if (initialView && initialView.dataView && initialView.dataView.showSerialPopup) {
					initialView.dataView.showSerialPopup(e);
				}
			});

            layout.addToViewEventsDefinition(
				'ProductList.Control.View',
				'click [data-action="show-login-register-popup"]',
			function (e) 
			{
				e.stopPropagation();
				e.preventDefault();

				var view = new LoginRegisterView({
					application: layout.application
				});

				if (view)
				layout.showContent(view, {showInModal: true});
			});

			layout.addToViewEventsDefinition(
				'Transaction.Line.Views.Price.View',
				'click [data-action="show-login-register-popup"]',
			function (e) 
			{
				e.stopPropagation();
				e.preventDefault();

				var view = new LoginRegisterView({
					application: layout.application
				});

				if (view)
				layout.showContent(view, {showInModal: true});
			});

			layout.addToViewEventsDefinition(
				'ItemRelations.RelatedItem.View',
				'click [data-action="show-login-register-popup"]',
			function (e) 
			{
				e.stopPropagation();
				e.preventDefault();

				var view = new LoginRegisterView({
					application: layout.application
				});

				if (view)
				layout.showContent(view, {showInModal: true});
			});


			layout.addToViewEventsDefinition(
				'ProductViews.Price.View',
				'click [data-action="show-login-register-popup"]',
			function (e) 
			{
				e.stopPropagation();
				e.preventDefault();

				var view = new LoginRegisterView({
					application: layout.application
				});

				if (view)
				layout.showContent(view, {showInModal: true});
			});

			//console.log(layout)

			 pdpComponent.addToViewEventsDefinition(
				'ProductDetails.Full.View',
				'click [data-action="make-an-offer"]',
			function (e) 
			{
				
				var $element = jQuery(e.currentTarget);
		    	var pdp = container.getComponent("PDP");
				var iteminfo = pdp.getItemInfo();
				var item = iteminfo.item;
				
				//console.log(item)

		    	//var Layout = SC.Application('Shopping').getComponent('Layout');
		    	var PopupView = new MakeAnOfferView({
					itemid: item.itemid,
					internalid : item.internalid,
					itemname : item.displayname,
					configuration : Configuration,
					layout : layout,
					item: item
				});
				if (PopupView)
					layout.showContent(PopupView, {showInModal: true});
			})

            layout.addToViewEventsDefinition(
				'ItemRelations.RelatedItem.View',
				'mousedown [data-action="minus"]',
			function (e) 
			{
				const $element = jQuery(e.currentTarget);
		        const quantity_input = $element.parent().find('.item-quantity-value');
		       	const find_title_ele = $element.closest('.e2');
		        const old_value = quantity_input.text();
		       	const cart = container.getComponent('Cart');
		    	var lines=[];

		        if(old_value==1 )
		        {
		        	var parentEle = $element.parent('.plus-icon');
			        if(parentEle.hasClass('expand-plus-icon'))
			        parentEle.removeClass('expand-plus-icon');

		        	find_title_ele.removeClass('newly-added-css');
		        	let new_val = parseFloat(old_value) - 1;
					quantity_input.text(new_val);
		        	$element.attr("style","display:none !important;");
		        	quantity_input.hide();
		        }
		        else if(old_value>1 ){
		        	let new_val = parseFloat(old_value) - 1;
		        	quantity_input.text(new_val);

		        	if(old_value == 2)
		        	{
		        		var trashCane = $element.parent().find('.product-trash-tray');
				    	var button_minus = $element.parent().find('.minus-button');
				    	//console.log(button_minus)
				    	button_minus.attr("style","display:none !important;");
				    	trashCane.show();
				    	quantity_input.css('text-align','left');
			        	
		        	}
		        }
		    	var internalID=quantity_input.attr("data-id");
				
				var liveOrder = LiveOrderModel.getInstance();
				
				var lineData=liveOrder.get('lines').filter(function(line)
				{	
					return line.get('item').get('internalid') == internalID;
		       	});
		       	var lineQuantity=lineData[0].get('quantity');
		       	
		       	if(lineQuantity==1)
		       		liveOrder.removeLine(
		       		lineData[0].set('quantity',parseFloat(lineQuantity)-1));
		    	else
		    	{
		    		liveOrder.updateLine(
		       		lineData[0].set('quantity',parseFloat(lineQuantity)-1));
		       		setTimeout(function(){
		    			if(!Utils.isPhoneDevice())
		    				jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
		    		}, 1000);
		    	}
			});

			layout.addToViewEventsDefinition(
				'ItemRelations.RelatedItem.View',
				'mousedown [data-action="plus"]',
			function (e) 
			{	
				e.stopPropagation();
				e.preventDefault();
			
				var self=this;
				var $element = jQuery(e.currentTarget);
		        var quantity_input = $element.parent().find('.item-quantity-value');
		        var button_minus = $element.parent().find('.minus-button');
		       	var find_title_ele = $element.closest('.e2');
		       	var cart = container.getComponent('Cart');
		    	var lines=[];

		    	var itemQtyInCurrentOrder = 0;

		    	var itemOrigin = 'ItemRelations';

		    	
				var liveOrder = LiveOrderModel.getInstance();
				var internalID=quantity_input.attr("data-id");
				//var item = this.model.get('item');
				//console.log(quantity_input)
				
				var lineData=liveOrder.get('lines').filter(function(line)
				{	
					return line.get('item').get('internalid') == internalID/*item.get('internalid')*/;
		       	});
		       	
		       	if(lineData.length > 0)
		       	{
		       	var lineQuantity=lineData[0].get('quantity');
		       	itemQtyInCurrentOrder = lineQuantity;
		       	}

			    var elementParent = $element.parent('.'+itemOrigin+'.plus-icon');		
				//console.log(elementParent)

		    	var trashCane = $element.parent().find('.product-trash-tray');
		    	   	
		    	//debugger
		       // console.log(find_title_ele)
		        quantity_input.show();
		       // button_minus.show();

		         var parentEle = $element.parent('.'+itemOrigin+'.plus-icon');
		        if(!(parentEle.hasClass('expand-plus-icon')))
		        parentEle.addClass('expand-plus-icon');

		        find_title_ele.addClass('newly-added-css');
		        
		        var old_value = quantity_input.text();

		        if(elementParent.hasClass('add-to-cart-buttons-opened'))
		        {
				var new_val = parseFloat(old_value) == 0 ? 1 : parseFloat(old_value)+1; 
				quantity_input.text(new_val);
				}
				
				//console.log(old_value)


				var quantity = quantity_input.text();
				var internalID=quantity_input.attr("data-id");

				//console.log(quantity)

				if(quantity == 1)
		        {
		        	trashCane.show();
		        	button_minus.hide();
		        	quantity_input.css('text-align','left');
		        	
		        }
		        else	
		        {
		        	 button_minus.show();
		        	trashCane.hide();
		        	quantity_input.css('text-align','center');
		        }

				
				if(quantity>0)
				{	
					if(itemQtyInCurrentOrder && !(elementParent.hasClass('add-to-cart-buttons-opened')))
					{
						$element.text('+');
						$element.removeClass('plus-button-additional');

						elementParent.addClass('add-to-cart-buttons-opened');
						elementParent.removeClass('plus-icon-additional');

					}else
					{
						var lineData={quantity: parseFloat(1),
							  		  item: {internalid: parseFloat(internalID)}
						};
						lines.push(lineData);
						SC.loadingIndicatorShow();
						cart.addLines({lines: lines}).then(function() {
							SC.loadingIndicatorHide();
							if(!Utils.isPhoneDevice())
							jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
						});
						elementParent.addClass('add-to-cart-buttons-opened');	
					}
				}	
				
			});

			layout.addToViewEventsDefinition(
				'ItemRelations.RelatedItem.View',
				'click [data-action="item-quick-view"]',
			function (e) 
			{
				e.preventDefault();
	   			e.stopPropagation();
	   			
				NXTurnShoppingExtensionsHomeHeader.showQuickView(e,environment.application,layout);
			});

			layout.addToViewEventsDefinition(
				'ProductDetails.Full.View',
				'click [data-action="customize-kit"]',
			function (e) 
			{
				e.preventDefault();
	   			e.stopPropagation();
	   			//console.log(layout)
				NXTurnShoppingExtensionsHomeHeader.showQuickView(e,environment.application,layout);
			});


			/*layout.addToViewEventsDefinition(
				'ProductDetails.Full.View',
				'click [data-action="add-to-cart-from-pdp"]',
			function (e) 
			{
				console.log(e)
			});*/

			ProductDetailsFullView.addChildViews({	            
		            'CurrentItem.Qty.ToolTip': function wrapperFunction(options) {		            	
		                return function() {
		                	var pdp = container.getComponent("PDP");
							var iteminfo = pdp.getItemInfo();

							var pdp_layout = pdp.application.layout
							,   pdp_layout_currentview = pdp_layout.currentView
		                	//console.log(pdp_layout_currentview)

		                	 return new PDPQtyToolTip({
							  	application: environment.application,
							  	layout : layout,
							  	iteminfo : iteminfo,
							  	configuration : Configuration,
							  	container : container,
							  	parentView : pdp_layout_currentview
							  });
		                };
		            }
		        });

			ProductDetailsBaseView.prototype.getContext = _.wrap(ProductDetailsBaseView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);	

			//console.log(this.model);
			var mod = this.model
			,   item = mod.get('item')
			,   resources1 = item.get('custitem_resource1')
			,   qtyAvailableInv = item.get('custitem_qty_available_inv')
			,   qtyAvailableKit = item.get('custitem_qty_available_kit')
			,   itemType = item.get('itemtype')
			,   manufacturer = item.get('custitem_manufacturer')
			,   productGroup = item.get('custitemproduct_category')
			,   itemCondition = item.get('custitem123')
			,   lightboxItemURL = item.get('custitem_lightbox_item_url_component')
			,   enableOutOfStock = item.get('custitem_celigo_shopify_enable_out_sto')
			,   kitItemOnly = item.get('custitem_kit_item_only') 
			,   finalLightboxUrl = ''
			,   showCustomizeKitButton = false
			,   showOutofStock = false
			,   showProductHeighlight = false
			,   productHeighlight = item.get('custitem198')
			,   showLimitedStock = false
			,   kitUpFunctionalityItems = item.get('custitem_kit_up_feature_items')
			,   isStrykerProduct = false
			,   pdpStrykerMessage = Configuration.PDPStrykerMessage
			,   pdpStrykerMessageConfig = pdpStrykerMessage.config
			//,   showContactForPricingButton = false
			,   special_formatted_pricelevel1 = ''
            ,   special_formatted_pricelevel5 = ''
            ,   itemIsinBag = false
            ,   pdpSerialLotFunctionality = item.get('custitem_pdp_seriallot_number_function')  
            ,   productSubCategory = item.get('custitem168')
            ,   outOfStockDisplay = item.get('custitem_aa_out_of_stock_display')
            ,   showContactForPricingButton = false
            ,   showOutOfStockButton = false

			

            var liveOrder = LiveOrderModel.getInstance();
            //console.log(item)
            
            var lineData=liveOrder.get('lines').filter(function(line)
            {   
                return line.get('item').get('internalid') == item.get('internalid');
            });
          
            if(lineData.length > 0)
            {
	            var lineQuantity=lineData[0].get('quantity');
	           // qtyInBag = lineQuantity;
	            itemIsinBag = true;
	            //console.log(lineQuantity)
            }

			var price_detail = item.get('onlinecustomerprice_detail')
			if(price_detail)
            {
            	var pricelevel1 = item.get('pricelevel1')
                ,   pricelevel1_formatted = item.get('pricelevel1_formatted')
               // ,   pricelevel5 = price_detail.onlinecustomerprice
                ,   pricelevel5_formatted = price_detail.onlinecustomerprice_formatted
                ,   onlinecustomerprice_detail = price_detail
                ,   applyStrikeThroughPrice = false
                ,   onlineprice = onlinecustomerprice_detail.onlinecustomerprice
                ,   pricelevel5 = onlinecustomerprice_detail.onlinecustomerprice
                ,   ItemPrice = onlinecustomerprice_detail.onlinecustomerprice_formatted
				,	savePrice = 0
				,	savePercent=0
				,	discountPercentage=0;

                if(pricelevel1 && pricelevel1 > onlineprice)
                {
                    //console.log(pricelevel1.toLocaleString('en'));
                    applyStrikeThroughPrice = true;
                }

                if(pricelevel1_formatted)
                    special_formatted_pricelevel1 = pricelevel1_formatted.substr(0, pricelevel1_formatted.indexOf('.'));
                
                if(pricelevel5_formatted)
                    special_formatted_pricelevel5 = pricelevel5_formatted.substr(0, pricelevel5_formatted.indexOf('.'));
                
                //console.log(item)

                /*var currPrice = pricelevel5 || pricelevel1 || 0; 
	            if( currPrice < 5){
	                showContactForPricingButton = true;
	            }*/
                
            } 

			if(qtyAvailableInv == undefined)
				qtyAvailableInv = 0;

			if(qtyAvailableKit == undefined)
				qtyAvailableKit = 0;


			var itemPrice = item.get('onlinecustomerprice_detail').onlinecustomerprice;

			if(kitUpFunctionalityItems == '&nbsp;')
			kitUpFunctionalityItems = []
			
			//console.log(manufacturer)
			if(manufacturer == "Stryker" || manufacturer == "stryker")
				isStrykerProduct = true;


			if(productHeighlight)
			showProductHeighlight = true;

			
			
			if(lightboxItemURL !== '' /*&& kititemonly == true*/)
			{
				finalLightboxUrl = "/"+lightboxItemURL;
				showCustomizeKitButton = true;
			}

			if(itemType == "Kit")
			{
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableKit <= 0 && enableOutOfStock == false)
				{
					showOutofStock = true;

					if(outOfStockDisplay == "Out of Stock")
						showOutOfStockButton = true;
					else if(outOfStockDisplay == "Contact for Pricing")
						showContactForPricingButton = true;
				}
				
				//For LimitedStock 
				if(qtyAvailableKit <= 5 && qtyAvailableKit > 0)
				{
					showLimitedStock = true;
				}
			}
			else if(itemType == 'InvtPart' || itemType == 'Assembly')
			{
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableInv <= 0 && enableOutOfStock == false)
				{
					showOutofStock = true;

					if(outOfStockDisplay == "Out of Stock")
						showOutOfStockButton = true;
					else if(outOfStockDisplay == "Contact for Pricing")
						showContactForPricingButton = true;
				}
				
				//FOr LimitedStock 
				if(qtyAvailableInv <= 5 && qtyAvailableInv > 0)
				{
				    showLimitedStock = true;
				}
			}

			/*if(kitItemOnly == true)
				showContactForPricingButton = true;*/

			//console.log(enableOutOfStock);
			//console.log(showContactForPricingButton);
			 if(applyStrikeThroughPrice)
            {
            	savePrice = parseFloat((Number(pricelevel1) - Number(pricelevel5)).toFixed(2));
            	discountPercentage = (savePrice / pricelevel1) * 100;
            	savePercent=Math.trunc(discountPercentage)+ "%";
            }
			var bogoConfig = Configuration.PRODUCTPAGEBOGO || {};
			var bogoItemsList = bogoConfig.config || [];
			var showBOGO = false;
			var currentItemId = String(item.get('internalid'));
			//console.log(bogoItemsList)
			for (var b = 0; b < bogoItemsList.length; b++) {
				if (String(bogoItemsList[b].itemid) === currentItemId) {
					showBOGO = true;
					break;
				}
			}



			_.extend(result, {
							resources1 : resources1,
							isPhoneDevice : Utils.isPhoneDevice(),
							itemType : itemType,
							itemCondition : itemCondition,
							lightBoxItemURL : finalLightboxUrl,
							showCustomizeKitButton : showCustomizeKitButton,
							showOutofStock : showOutofStock,
							showLimitedStock : showLimitedStock,
							//kitItemOnlyChecked : kititemonly,
							safariBrowserMac : (typeof navigator !== 'undefined' && navigator.vendor.indexOf('Apple') > -1) ? true : false,
							productGroup : productGroup,
							productSubCategory : productSubCategory,
							shopProductGroup : (productGroup !== '&nbsp;' && productGroup !== '') ? true : false,
							manufacturer : manufacturer,
							showProductHeighlight : showProductHeighlight,
							productHeighlight : productHeighlight,
							showAddToCart : itemPrice !== null ? true : false,
							isCurrentItemPurchasable: item.get('_isPurchasable'),
							//hasKitUpItems : kitUpFunctionalityItems,
							isStrykerProduct : isStrykerProduct,
							pdpStrykerMessageConfig : pdpStrykerMessageConfig,
							//serialNumberLightbox : serialNumberLightbox,
							showContactForPricingOutOfStockButton : showContactForPricingButton,
							showOutOfStockButton : showOutOfStockButton,
							itemIsinBag : itemIsinBag,
							savePrice : savePrice,
							savePercent:savePercent,
							pdpSerialLotFunctionality: pdpSerialLotFunctionality,
							kitItemPageOnly : (item.get('itemtype') === 'Kit' && pdpSerialLotFunctionality) ? true : false,
							showBOGO : showBOGO
						});

			//console.log(result);

			return result;
			});


			ProductDetailsFullView.prototype.getContext = _.wrap(ProductDetailsFullView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);

			var nav_data = Configuration.navigationData
			,   finalHREF = ''

			var mod = this.model
			,   item = mod.get('item')
			,   itemManufacturer = item.get('custitem_manufacturer')
			
			var findManufacturer = _.findWhere(nav_data, {
	                    href: '/manufacturers'
	                });

			if(findManufacturer){
				var manufactCategories = findManufacturer.categories;
				var findTargetedManufacturer = _.findWhere(manufactCategories, {
	                    text: itemManufacturer
	                });
				if(findTargetedManufacturer)
				finalHREF = findTargetedManufacturer.href;
				//console.log(findTargetedManufacturer);
			}
			

			_.extend(result, {					
							isPhoneDevice : Utils.isPhoneDevice(),
							finalManufacturerHREF :finalHREF
						});
			//console.log(result)
			return result;
			});

			ProductDetailsImageGalleryView.prototype.getContext = _.wrap(ProductDetailsImageGalleryView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);

			var images = this.model.getImages();

			 var iteminfo = pdpComponent.getItemInfo()

			 //console.log(this.$('[data-slider]'))

			 // Check if this item has SerialLot PDP functionality enabled AND is a lot item
			 var isSerialLotPDP = false;
			 if(iteminfo){
			 	var   item = iteminfo.item
			 	,   displayname = item.displayname
			 	,   serialLotValue = item.custitem_pdp_seriallot_number_function
			 	,   isLotItem = item.islotitem
			 	
			 	var hasSerialLotFunc = serialLotValue === true || serialLotValue === 'T';
			 	var isLot = isLotItem === true || isLotItem === 'T';
			 	isSerialLotPDP = hasSerialLotFunc && isLot;

				 if(images && images.length > 0){
				 	_.each(images, function (img) {
				 		img.altimagetext = displayname;
				 	});
				 }
			 }
			 


			_.extend(result, {					
					isPhoneDevice : Utils.isPhoneDevice(),
					imagesUpdated: images || [],
		            firstImageUpdated: images[0] || {},
		            isSerialLotPDP: isSerialLotPDP
			});
			//console.log(images)
			return result;
			});

			ProductDetailsQuantityView.prototype.getContext = _.wrap(ProductDetailsQuantityView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);


			
			var pdpQtyModel = result.model
			,   itemData = pdpQtyModel.get('item')
			,   qtyAvailableInv = itemData.get('custitem_qty_available_inv')
			,   qtyAvailableKit = itemData.get('custitem_qty_available_kit')
			,   itemType = itemData.get('itemtype')
			,   itemAvailableQuantity = ''
			,   itemAvailableQuantityArray = []

			if(qtyAvailableInv == undefined)
				qtyAvailableInv = 0;

			if(qtyAvailableKit == undefined)
				qtyAvailableKit = 0;

			if(itemType == 'Kit')
			{
				if(qtyAvailableKit > 0)
				itemAvailableQuantity = qtyAvailableKit;
			}
			else if(itemType == 'InvtPart' || itemType == 'Assembly')
			{
				if(qtyAvailableInv > 0)
				itemAvailableQuantity = qtyAvailableInv;
			}

			//console.log(itemAvailableQuantity)
			for(var a=1;a<=itemAvailableQuantity;a++){
				itemAvailableQuantityArray.push(a)
			}
			//console.log(itemAvailableQuantityArray)
			_.extend(result, {					
							itemAvailableQuantityArray : itemAvailableQuantityArray
						});

			return result;
			});
			

			layout.addToViewContextDefinition('ProductDetailToQuote.View', 'isLoggedIn', 'boolean', function(context) {
			            //console.log(is_logged_in)
			            return (profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F')
			      });

			layout.addToViewContextDefinition('ProductDetailToQuote.Confirmation.View', 'isPhoneDevice', 'boolean', function(context) {
			            //console.log(is_logged_in)
			            return Utils.isPhoneDevice();
			      });

			// PDP "Add to Quote" flow (ProductDetailToQuote.View.itemToQuote) sets each condition
			// line option as { internalid: <numeric list-record id>, label: <display value> }.
			// The NS transaction columns (custcol_functional_condition, custcol_cosmetic_condition,
			// custcol_disposable_condition) are Free-Form Text � they receive `internalid`, so the
			// estimate ended up showing raw ids like "1" / "8" instead of "Certified" / "Good".
			// The Sales Order flow has no such issue because it never sets these custcols directly;
			// a server-side User Event on SO derives them from custcol_webstore_temp_data.
			// Fix: at the ProductList.Item.Model save choke point (which every add-to-quote line
			// passes through), rewrite the three condition options so `internalid` becomes the label
			// too. `.label` is untouched, so the RQW items list keeps rendering the same value.
			(function () {
				var CONDITION_CARTOPTION_IDS = [
					'custcol_functional_condition',
					'custcol_cosmetic_condition',
					'custcol_disposable_condition'
				];

				var originalSave = ProductListItemModel.prototype.save;

				ProductListItemModel.prototype.save = function () {
					try {
						var options = this.get('options');
						if (options) {
							// Options can be a Backbone Collection OR a plain array depending on
							// whether the parse event has already run � SCA source comments call this out.
							if (_.isFunction(options.each)) {
								options.each(function (opt) {
									if (_.contains(CONDITION_CARTOPTION_IDS, opt.get('cartOptionId'))) {
										var val = opt.get('value');
										if (val && val.label) {
											opt.set('value', { internalid: val.label, label: val.label });
										}
									}
								});
							} else if (_.isArray(options)) {
								_.each(options, function (opt) {
									if (opt && _.contains(CONDITION_CARTOPTION_IDS, opt.cartOptionId)) {
										if (opt.value && opt.value.label) {
											opt.value = { internalid: opt.value.label, label: opt.value.label };
										}
									}
								});
							}
						}
					} catch (e) { /* never block save on our patch */ }
					return originalSave.apply(this, arguments);
				};
			})();

			

			layout.addToViewContextDefinition('ProductList.Control.View', 'isLoggedIn', 'boolean', function(context) {
			            //console.log(is_logged_in)
			            return (profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F')
			      });

			ProductViewsPriceView.prototype.getContext = _.wrap(ProductViewsPriceView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);	

			var item = this.model.get('item')
			,   price_container_object = this.model.getPrice()
			,   pricelevel1 = ''
			,   pricelevel5 = ''
			,   pricelevel1_formatted = ''
			,   onlinecustomerprice_detail = ''
			,   applyStrikeThroughPrice = false
			,   onlineprice = ''
			,   special_formatted_pricelevel1 = ''
			,   special_formatted_pricelevel5 = ''
			,   isKitItemOnly = ''
			,   showOutofStock = false
			,	savePrice = 0
			,	savePercent=0
			,	discountPercentage=0;
			if(item)
			{
				pricelevel1 = item.get('pricelevel1')
				pricelevel1_formatted = item.get('pricelevel1_formatted')
				pricelevel5 = item.get('onlinecustomerprice')
				onlinecustomerprice_detail = item.get('onlinecustomerprice_detail')
				if(onlinecustomerprice_detail)
				onlineprice = onlinecustomerprice_detail.onlinecustomerprice

				var qtyAvailableInv = item.get('custitem_qty_available_inv')
	            ,   qtyAvailableKit = item.get('custitem_qty_available_kit')
	            ,   itemType = item.get('itemtype')
	            ,   enableOutOfStock = item.get('custitem_celigo_shopify_enable_out_sto')
	            ,   isWebsiteCategoryProduct = item.get('custitem157')
	            ,   isKitItemOnly = item.get('custitem_kit_item_only') 
	            ,   outOfStockDisplay = item.get('custitem_aa_out_of_stock_display')
	            ,   showContactForPricingButton = false
	            ,   showOutOfStockButton = false


	            if(qtyAvailableInv == undefined)
				qtyAvailableInv = 0;

				if(qtyAvailableKit == undefined)
				qtyAvailableKit = 0;
	           
	            if(itemType == "Kit")
	            {
	                //Item Qty is 0 and Allow out of stock checkbox is not checked
	                if(qtyAvailableKit <= 0 && enableOutOfStock == false)
	                {
	                    showOutofStock = true;

	                    if(outOfStockDisplay == "Out of Stock")
							showOutOfStockButton = true;
						else if(outOfStockDisplay == "Contact for Pricing")
							showContactForPricingButton = true;
	                }
	            }
	            else if(itemType == 'InvtPart' || itemType == 'Assembly')
	            {
	                //Item Qty is 0 and Allow out of stock checkbox is not checked
	                if(qtyAvailableInv <= 0 && enableOutOfStock == false)
	                {
	                    showOutofStock = true;

	                    if(outOfStockDisplay == "Out of Stock")
							showOutOfStockButton = true;
						else if(outOfStockDisplay == "Contact for Pricing")
							showContactForPricingButton = true;
	                }
	            }

				if(pricelevel1 && pricelevel1 > onlineprice)
				{
					//console.log(pricelevel1.toLocaleString('en'));
					applyStrikeThroughPrice = true;
				}
				//console.log(pricelevel1_formatted)
				if(pricelevel1_formatted)
				special_formatted_pricelevel1 = pricelevel1_formatted.substr(0, pricelevel1_formatted.indexOf('.'));
				
				if(price_container_object)
				{
					onlineprice = price_container_object.price_formatted;
					if(onlineprice)
					special_formatted_pricelevel5 = onlineprice.substr(0, onlineprice.indexOf('.'));
				}

				var currPrice = pricelevel5 || pricelevel1 || 0; 
	            if( currPrice < 5){
	                showOutofStock = true;
	            }	
			}

			/*if(isKitItemOnly == true)
                showOutofStock = true;*/

			if(applyStrikeThroughPrice)
				{
					savePrice = parseFloat((Number(pricelevel1) - Number(pricelevel5)).toFixed(2));
					discountPercentage = (savePrice / pricelevel1) * 100;
					savePercent=Math.trunc(discountPercentage)+ "%";
				}
            //console.log(item)
           

			//console.log(showOutofStock)
			
			_.extend(result, {					
							applyStrikeThroughPrice : applyStrikeThroughPrice,
							BasePriceFormatted : special_formatted_pricelevel1,
							OnlinePriceFormatted : special_formatted_pricelevel5,
						    hidePrice : showOutofStock,
							savePrice : savePrice,
							savePercent:savePercent,
							isContactPricingOOS : showOutOfStockButton || showContactForPricingButton
			                //BasePrice : pricelevel1.toLocaleString('en'),
							//OnlinePrice : onlineprice.toLocaleString('en')
						});

			//console.log(result);

			return result;
			});

			layout.addChildView('AddToProductListCustom', function () 
		        {
		        	var iteminfo = pdpComponent.getItemInfo()
			   		,   item = iteminfo.item

		        	//console.log(layout)
		          return new AddToWishlistView(
		                {
		                	application: layout.application,
		                	 item: item
		                });
		        });

			 /*layout.addChildView('AddToWishlist.RightSide', function () 
		        {
		        	var iteminfo = pdpComponent.getItemInfo()
			   		,   item = iteminfo.item

			   		//console.log(iteminfo)

		        	var header_view_options = _.extend(
	                {
	                    application: layout.application,
	                    item: item
	                },
	                {}
	            );

	            return new AddToWishlistRightSideView(header_view_options);
		        });*/


			
			layout.addToViewEventsDefinition(
				'ProductDetails.Full.View',
				'click [data-action="contact-for-pricing"]',
			function (e) 
			{

				var $element = jQuery(e.currentTarget);
		    	var pdp = container.getComponent("PDP");
				var iteminfo = pdp.getItemInfo();
				var item = iteminfo.item;
				
				//console.log(item)

		    	//var Layout = SC.Application('Shopping').getComponent('Layout');
		    	var ContactPricingView = new ContactForPricingView({
					itemid: item.itemid,
					internalid : item.internalid,
					itemname : item.displayname,
					configuration : Configuration
				});
				if (ContactPricingView)
					layout.showContent(ContactPricingView, {showInModal: true});
			});

		}
	};
});
